



















import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Permission } from '@/interfaces/user.interface';

const usersModule = namespace('users');
@Component
export default class PermissionsTable extends Vue {
  @usersModule.State permissions!: Permission[];
}
